var _defs, _path, _path2, _path3, _line, _line2, _line3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 313.02 379.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:24px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.85,120.06l13.09,230.96c.51,9,7.96,16.04,16.97,16.04H251.85c8.99,0,16.42-7,16.97-15.97l14.03-231.03H29.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,58.47h249.02c11.04,0,20,8.96,20,20v35.6c0,3.31-2.69,6-6,6H18c-3.31,0-6-2.69-6-6v-35.6c0-11.04,8.96-20,20-20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132,12h49.53c13.25,0,24,10.75,24,24v22.47H108v-22.47c0-13.25,10.75-24,24-24Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 156.51,
    y1: 168.1,
    x2: 156.51,
    y2: 320.78
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 216.88,
    y1: 168.1,
    x2: 216.88,
    y2: 320.78
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.78,
    y1: 168.1,
    x2: 97.78,
    y2: 320.78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.5abeadb6bb0f15305e6eb1321478f465.svg";
export { ForwardRef as ReactComponent };